/**
 * Check if Web Share API is supported
 */
export const isWebShareSupported = () => {
    return typeof navigator !== 'undefined' && navigator.share !== undefined;
};

/**
 * Check if file sharing is supported
 */
export const isFileShareSupported = () => {
    if (!isWebShareSupported()) return false;

    // Desktop browsers often have Web Share API but don't support file sharing
    // Check if we're on mobile/tablet
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    if (!isMobile) {
        // Desktop browsers: Chrome/Edge support file sharing, but it's unreliable
        // Better to show menu fallback on desktop
        return false;
    }

    // Check if canShare supports files
    if (navigator.canShare) {
        try {
            const testFile = new File(['test'], 'test.txt', { type: 'text/plain' });
            return navigator.canShare({ files: [testFile] });
        } catch (e) {
            return false;
        }
    }
    return false;
};

/**
 * Share using Web Share API
 */
export const shareViaWebAPI = async (shareData) => {
    if (!isWebShareSupported()) {
        throw new Error('Web Share API not supported');
    }

    try {
        // Check if we can share this data
        if (navigator.canShare && !navigator.canShare(shareData)) {
            throw new Error('Cannot share this data');
        }

        await navigator.share(shareData);
        return { success: true };
    } catch (error) {
        // User cancelled or error occurred
        if (error.name === 'AbortError') {
            return { success: false, cancelled: true };
        }
        throw error;
    }
};

